/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-a26b9c60.mjs';
import { defineComponent, ref, provide, createVNode } from 'vue';
import { i as isNil_1 } from '../_chunks/dep-2311acd8.mjs';
import { i as isArray_1 } from '../_chunks/dep-0d1bd08c.mjs';
import { LayoutEnum } from '../common.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import { useChildComponentSlots } from '../hooks/slot.mjs';
import { usePrefixClass, useCommonClassName } from '../hooks/useConfig.mjs';
import props from './props.mjs';
import { descriptionsKey } from './const/index.mjs';
import DescriptionsRow from './descriptions-row.mjs';
import { renderCustomNode, itemTypeIsProps } from './utils/index.mjs';
import { ItemsType } from './interface.mjs';
import '../_chunks/dep-b333ab93.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-97c71289.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-4efc69ee.mjs';
import '../_chunks/dep-0a6fd248.mjs';
import '../_chunks/dep-7ad89920.mjs';
import '../_chunks/dep-c5d88cfe.mjs';
import '../_chunks/dep-36563716.mjs';
import '../_chunks/dep-8049d2e0.mjs';
import '../_chunks/dep-b1013215.mjs';
import '../_chunks/dep-91fc304f.mjs';
import '../_chunks/dep-17446155.mjs';
import '../_chunks/dep-8747fcf0.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ec227f3f.mjs';
import '../_chunks/dep-18bb982b.mjs';
import '../_chunks/dep-25d66c95.mjs';
import '../_chunks/dep-372265bb.mjs';
import '../_chunks/dep-ae08d6c4.mjs';
import '../_chunks/dep-d940e2da.mjs';
import '../_chunks/dep-e50fa7b0.mjs';
import '../_chunks/dep-c57d8117.mjs';
import '../_chunks/dep-c7e4942d.mjs';
import '../_chunks/dep-5f6c8826.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-493c38ce.mjs';
import '../_chunks/dep-b56b2dc0.mjs';
import '../_chunks/dep-77f634fb.mjs';
import '../_chunks/dep-28ae3cda.mjs';
import '../_chunks/dep-7211604f.mjs';
import '../_chunks/dep-75df64b1.mjs';
import '../_chunks/dep-48b9a098.mjs';
import '../_chunks/dep-52c1d6a9.mjs';
import '../_chunks/dep-6043e9fc.mjs';
import '../_chunks/dep-3a045465.mjs';
import '../_chunks/dep-53dc0ac1.mjs';
import '../_chunks/dep-b6b4eaa3.mjs';
import '../_chunks/dep-881cffb7.mjs';
import '../_chunks/dep-436b338d.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-2d31a683.mjs';
import '../_chunks/dep-3ddc95d0.mjs';
import '../config-provider/type.mjs';

var _Descriptions = defineComponent({
  name: "TDescriptions",
  props: props,
  setup: function setup(props2) {
    var COMPONENT_NAME = usePrefixClass("descriptions");
    var _useCommonClassName = useCommonClassName(),
      SIZE = _useCommonClassName.SIZE;
    var getChildByName = useChildComponentSlots();
    var renderTNodeJSX = useTNodeJSX();
    var itemsType = ref(ItemsType.props);
    var getRows = function getRows() {
      var column = props2.column,
        layout = props2.layout;
      var items = [];
      if (isArray_1(props2.items)) {
        items = props2.items.map(function (item) {
          return {
            label: renderCustomNode(item.label),
            content: renderCustomNode(item.content),
            span: item.span || 1
          };
        });
        itemsType.value = ItemsType.props;
      } else {
        var slots = getChildByName("TDescriptionsItem");
        if (slots.length !== 0) {
          items = slots;
          itemsType.value = ItemsType.slots;
        }
      }
      if (layout === LayoutEnum.VERTICAL) {
        return [items];
      }
      var temp = [];
      var reset = column;
      var res = [];
      items.forEach(function (item, index) {
        var span = 1;
        if (itemTypeIsProps(itemsType.value, item)) {
          span = isNil_1(item.span) ? span : item.span;
        } else {
          var _item$props;
          item.props = item.props || {};
          span = isNil_1((_item$props = item.props) === null || _item$props === void 0 ? void 0 : _item$props.span) ? span : item.props.span;
          item.props.span = span;
        }
        if (reset >= span) {
          temp.push(item);
          reset -= span;
        } else {
          res.push(temp);
          temp = [item];
          reset = column - span;
        }
        if (index === items.length - 1) {
          if (itemTypeIsProps(itemsType.value, item)) {
            item.span += reset;
          } else {
            item.props.span += reset;
          }
          res.push(temp);
        }
      });
      return res;
    };
    provide(descriptionsKey, props2);
    var renderBody = function renderBody() {
      var tableClass = ["".concat(COMPONENT_NAME.value, "__body"), SIZE.value[props2.size], _defineProperty({}, "".concat(COMPONENT_NAME.value, "__body--border"), props2.bordered)];
      return createVNode("table", {
        "class": tableClass
      }, [createVNode("tbody", null, [getRows().map(function (row) {
        return createVNode(DescriptionsRow, {
          "item-type": itemsType.value,
          "row": row
        }, null);
      })])]);
    };
    var renderHeader = function renderHeader() {
      var title = renderTNodeJSX("title");
      return title ? createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__header")
      }, [title]) : "";
    };
    return function () {
      return createVNode("div", {
        "class": COMPONENT_NAME.value
      }, [renderHeader(), renderBody()]);
    };
  }
});

export { _Descriptions as default };
//# sourceMappingURL=descriptions.mjs.map
